'use client';

import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@ui/components/ui/form';
import { Input } from '@ui/components/ui/input';
import { useTranslations } from 'next-intl';
import { Path, UseFormReturn } from 'react-hook-form';

interface FullNameInputProps<TFormValues extends { fullName: string }> {
  form: UseFormReturn<TFormValues>;
}

export default function FullNameInput<TFormValues extends { fullName: string }>({ form }: FullNameInputProps<TFormValues>) {
  const t = useTranslations('Form.account.fullName');

  return (
    <FormField
      control={form.control}
      name={'fullName' as Path<TFormValues>}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t('label')}</FormLabel>
          <FormControl>
            <Input type="text" placeholder={t('placeholder')} {...field} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
